import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { Group } from '@/models/features/posts.models'

import { authAPI } from '../new-api'

export type GetGroupsRequest = {
  buildingId?: number
  skip?: number
  limit?: number
  search?: string
}

export const GET_GROUPS_QUERY_KEY = 'useGetGroups'
export const getGroupsQueryKey = (data: GetGroupsRequest) => [GET_GROUPS_QUERY_KEY, data]

export const getGroups = async (data: GetGroupsRequest, signal?: AbortSignal) => {
  const { buildingId, ...params } = data
  const response = await authAPI.get<Group[]>(`/group/building/${buildingId}`, { params, signal })
  return response.data
}

export const useGetGroups = (data: GetGroupsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getGroups(data, signal),
    queryKey: getGroupsQueryKey(data),
  })
}
